import React, { useEffect, useState } from 'react';
import styles from '../styles/WhatsAppButton.module.css';
import { FaWhatsapp } from 'react-icons/fa';
import axios from 'axios';

const WhatsAppButton = () => {
  const [userEmail, setUserEmail] = useState('Não informado'); // Estado para armazenar o e-mail do usuário
  const whatsappNumber = '5551983422322'; // Número do WhatsApp

  useEffect(() => {
    const fetchUserEmail = async () => {
      const token = localStorage.getItem('token');
      if (!token) return;
    
      try {
        const response = await axios.get('https://crmesquita.com.br/api/get-user-email/', {
          headers: { Authorization: `Token ${token}` },
        });
        setUserEmail(response.data.email);
        console.log("E-mail do usuário:", response.data.email); // Log para depuração
      } catch (error) {
        console.error('Erro ao buscar o e-mail do usuário:', error);
        alert('Não foi possível buscar o e-mail do usuário. Tente novamente.');
      }
    };

    fetchUserEmail();
  }, []);

  const message = `Olá, sou um cliente do e-mail: ${userEmail}. Gostaria de mais informações sobre os serviços oferecidos pela CR Mesquita.`;
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.whatsappButton}
    >
      <FaWhatsapp className={styles.icon} />
    </a>
  );
};

export default WhatsAppButton;